export default function transformOptions(options) {
  return options.map((option) => ({ label: option?.name, value: option?.id ?? option?.name }));
}
